export const hasFiles = (dataTransfer: DataTransfer | null): boolean => {
  if (!dataTransfer) {
    return false;
  }

  // ファイルが含まれている場合
  if (dataTransfer.files && dataTransfer.files.length > 0) {
    return true;
  }

  // DataTransferのtypesにFilesが含まれているかチェック
  if (dataTransfer.types && dataTransfer.types.includes('Files')) {
    return true;
  }

  return false;
};
